import { FC } from 'react'

import { Text } from '@ds'

import styles from './CardSliderHeader.module.scss'
import { ProfileAvatarsListHeaderBorderIcon } from './icons'

type Props = {
  title: string
  count: number
}

export const CardSliderHeader: FC<Props> = ({ title, count }) => {
  return (
    <div className={styles.header}>
      <div className={styles.overlay} />
      <ProfileAvatarsListHeaderBorderIcon className={styles.headerBorder} />
      <div className={styles.titleContainer}>
        <Text type="h1" className={styles.title}>
          {title}
        </Text>
        <Text type="h1" className={styles.count}>
          {count}
        </Text>
      </div>
    </div>
  )
}
